import type { FetchControl } from '@/src/types/wallet'

export interface AbCookieConfig {
    [key: string]: string
}

/**
 * Stands in for `/source/abtest/getflyinpwaconfig` while that call is disabled, on the server and
 * in the browser alike. A visitor's own `ct-flyinPwaConfig` cookie still takes precedence.
 */
export const AB_CONFIG_STATIC: AbCookieConfig = {
    exp_2_ab_cookie: 'a',
    idParameter: 'IP',
    identifier: '45.127.46.43-Sat Oct 24 14:51:31 IST 2026',
    bff: 'a',
    signInFlow: 'b',
    exp_1_ab_cookie: 'a',
    hashValue: '04b48f0ec89febb2eef1650c5afee1adc0044872880293a0035b2a3f8394cb94'
}

export const isInternalEmail = (email?: string | null): boolean => {
    if (!email) return false
    const normalizedEmail = email.toLowerCase()
    return normalizedEmail.includes('@cleartrip') || normalizedEmail.includes('@flyin')
}

export const getEmailFromUseridCookie = (useridCookie?: string | null): string | null => {
    if (!useridCookie) return null
    try {
        const [email] = decodeURIComponent(useridCookie).split('|')
        return email || null
    } catch {
        return null
    }
}

export const parseAbCookie = (cookieValue?: string | null): AbCookieConfig | null => {
    if (!cookieValue) return null

    try {
        return JSON.parse(decodeURIComponent(cookieValue)) as AbCookieConfig
    } catch {
        return null
    }
}

export const getFetchControl = (
    isCleartripBrand: boolean,
    config?: AbCookieConfig | null,
    isInternalUser: boolean = false
): FetchControl => {
    if (isCleartripBrand) return 'MAIN'

    const shouldEnableMultiBrand = isInternalUser || config?.bff === 'b'
    return shouldEnableMultiBrand ? 'ALL' : 'MAIN'
}
